
import {
  makeStyles,
} from '@material-ui/core';

export default makeStyles((theme) => ({
  textFieldLabel: {
    color: 'rgba(0, 0, 0, 0.6)',
    textTransform: 'uppercase',
    letterSpacing: theme.typography.overline.letterSpacing,
    '&.Mui-disabled': {
      color: 'rgba(0, 0, 0, 0.6)',
    }
  },
  textFieldInput: {
    '&.Mui-disabled': {
      color: theme.palette.text.primary
    }
  },
  selectIcon: {
    color: theme.palette.primary.main
  },
  select: {
    '&.Mui-disabled': {
      color: theme.palette.text.primary
    }
  },
  selectSearch: {
    marginTop: theme.spacing(1) * -1,
    padding: 0,

    '&.Mui-selected, &.Mui-selected:hover': {
      backgroundColor: 'inherit'
    }
  },
  selectSearchInput: {
    padding: theme.spacing(1, 3)
  }
}));
